export default {
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
} as const
